export default __webpack_public_path__ + "static/media/invitaciones-enviadas.5ce5b84e.svg";